const templates =  {
    "shop.okraina.ru": {
        title: "Покупка от DATE_BUY",
        tags: [

        ]
    },
    "dostavka.okraina.ru": {
        title: "Покупка от DATE_BUY",
        tags: [
        ]
    },
}

export default templates;
